var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SGPMainTabComponent',[_c('SGPTabComponent',{attrs:{"title":"Listar"}},[_c('ListagemMenusComponent')],1),_c('SGPTabComponent',{attrs:{"title":"Associar Perfis"}},[_c('ListagemPerfilMenuComponent')],1),_c('SGPTabComponent',{attrs:{"title":"Menu vs Perfil"}},[_c('ListagemMenuXPerfilComponent')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }